import { RegisterApolloProvider } from '@daneroo/qcic-gql-client';
import { defaultHttpurl, MessagesSub, MessagesQyPoll } from "../../../../src/components/gql/GQLDemo";
import * as React from 'react';
export default {
  RegisterApolloProvider,
  defaultHttpurl,
  MessagesSub,
  MessagesQyPoll,
  React
};